import React, { useState, useEffect } from "react";
import {
  Card,
} from "reactstrap";
import Loader from "../../Components/Common/Loader";
import { ColorRange } from "./HeatmapCharts";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { POST_KPI_DASHBOARD } from "../../helpers/data_helper";
import {
  getDateByName,
  convertDateFormate,
} from "../../helpers/api_helper";
import { usePageApiQueue } from "../../Components/Hooks/PageApiQueue";

const FORECAST_API_PRIORITY = {
  ForcastTableOccChart: 3,
};

const ForcastTableOccChart = ({ mealPeriod, leftFilter, rightFilter, leftCustomDate, activeComparisonData, comparisonDate }) => {
  const [forecastHeatmapAjax, setForecastHeatmapAjax] = useState(true);
  const [forecastHeatmapData, setForecastHeatmapData] = useState({
    table: [],
    seat: [],
  });
  const { enqueue } = usePageApiQueue();

  useEffect(() => {
    if (
      leftFilter.value !== "Custom" ||
      (leftFilter.value === "Custom" && leftCustomDate[0] && leftCustomDate[1])
    ) {
      setForecastHeatmapAjax(true);
      return enqueue(
        "ForcastTableOccChart",
        FORECAST_API_PRIORITY.ForcastTableOccChart,
        async (signal) => {
          try {
            const response = await postDataAPI({
              serviceName: POST_KPI_DASHBOARD.serviceName,
              op: POST_KPI_DASHBOARD.forecast_heatmap_op,
              leftFilter:
                leftFilter.value === "Custom"
                  ? {
                    from: convertDateFormate(leftCustomDate[0]),
                    to: convertDateFormate(leftCustomDate[1]),
                  }
                  : getDateByName(leftFilter.value),
              rightFilter:
                activeComparisonData && activeComparisonData.datepiker
                  ? {
                    from: convertDateFormate(comparisonDate[0]),
                    to: convertDateFormate(comparisonDate[1]),
                  }
                  : getDateByName(rightFilter.value),
              mealPeriod: mealPeriod,
            }, signal);
            if (signal.aborted) return;
            setForecastHeatmapAjax(false);
            if (response.status === "ok") {
              setForecastHeatmapData(response.data);
            } else {
              console.log(response);
            }
          } catch (e) {
            if (!signal.aborted) setForecastHeatmapAjax(false);
          }
        }
      );
    }
  }, [
    // leftFilter,
    // leftCustomDate,
    // activeComparisonData,
    // rightFilter,
    mealPeriod,
    enqueue,
    // comparisonDate,
  ]);

  return (
    <Card>
      <div className="card-header px-2">
        <div className="d-flex align-items-start">
          <div className={`icon-box rounded bg-danger text-white`}>
            <i className="ri-bar-chart-fill"></i>
          </div>
          <div className="ps-2">
            <h4 className="card-title mb-1">
              Forecast Table Occupancy
            </h4>
            <p className="text-muted mb-0">
              Hourly table occupancy forecast with low to very high demand ranges.
            </p>
          </div>
        </div>
      </div>

      <div id="ForcastTableOccChart" className="card-body px-2">
        {forecastHeatmapAjax && <Loader />}
        <div
          className={forecastHeatmapAjax ? "opacity-0" : ""}
          style={{ maxWidth: "600px", margin: "0 auto" }}
        >
          <ColorRange
            forecastHeatmapData={forecastHeatmapData.table}
            dataText="Average Occ"
            dataColors='["--vz-danger", "--vz-secondary", "--vz-warning","--vz-success"]'
          />
        </div>
      </div>
    </Card>
  );
};

export default ForcastTableOccChart;
